import { order } from "../../../../shared/utils/array";
import { type FreightMethodModel } from "../../checkout/delivery-options/models";

export function getCheapestFreightMethod(methods: FreightMethodModel[]) {
    const newMethods = methods.filter(
        (m) => m.deliveryChoice === "FreightMethod"
    );

    if (newMethods.length === 0) return undefined;

    const cheapest = order(newMethods, (method) => method.price)[0];
    return cheapest;
}
